import { useQuery } from "urql";

import {
  GetTradeInsuranceStatisticsDocument,
  TradeInsuranceFilter,
  TradeInsuranceOrderBy,
} from "../../../graphql/generated.ts";
import { ApiHookProps } from "../types.ts";

export const useTradeInsuranceStatistics = ({
  filter,
}: ApiHookProps<TradeInsuranceFilter, TradeInsuranceOrderBy>) => {
  return useQuery({
    query: GetTradeInsuranceStatisticsDocument,
    variables: { filter },
  });
};
